import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import classnames from 'classnames';

import {MasonryImage} from './masonryImage/MasonryImage';

import logo from './logo.jpg';

import './masonryGallery.css';

function getImage({id, slug, photos:[{alt_sizes: sizes}]}) {
  const {url, width, height} = sizes[Math.max(sizes.length - 4, 0)];

  return (
    <MasonryImage
      key={id}
      link={`/gallery/${id}`}
      url={url}
      slug={slug}
      width={width}
      height={height}
    />
  );
}

export class MasonryGalleryComponent extends Component {

  static displayName = 'MasonryGallery';

  static propTypes = {
    showChildren: PropTypes.bool.isRequired,
    columns: PropTypes.object.isRequired,
  };

  state = {
    hidden: false
  };

  componentWillUpdate(newProps) {
    if (newProps.showChildren !== this.props.showChildren) {
      this.show();
      setTimeout(this.tryHide, 500);
    }
  }

  show = () => {
    this.setState({hidden: false})
  };

  tryHide = () => {
    if (this.props.showChildren) {
      this.setState({hidden: true})
    }
  };

  render() {
    const {columns, showChildren} = this.props;

    const columnComponents = columns.map(({images}, index) => (
      <div key={`column_${index}`} className="masonry-column">
        {index === 0 ? (
          <MasonryImage
            link={'/about'}
            slug="About Red Sea Tattoo"
            url={logo}
            width={416}
            height={632}
            noFade
          />
        ) : null}
        {images.toArray().map(getImage)}
      </div>
    ));

    return (
      <div className={classnames('masonry', {
        'masonry-hide': showChildren,
        'masonry-hidden': this.state.hidden,
      })} >
        {columnComponents}
      </div>
    );
  }
}

const mapStateToProps = ({images: {currentColumn: {columns}}}) => {
  return {
    columns,
  }
};

export const MasonryGallery = connect(mapStateToProps, {})(MasonryGalleryComponent);



// WEBPACK FOOTER //
// ./src/components/masonryGallery/MasonryGallery.js